import React from 'react'
import axios from "axios"
import moment from "moment";
import { useState } from 'react';
// import {BiSave} from "react-icons/bi"
import { IoMdSave } from "react-icons/io"
const SERVER_URL = process.env.REACT_APP_SERVER_URL


const OrderRow = ({ order, rerender, setRerender }) => {
    console.log(order);
    var statuses = ["Not Processed", "Processing", "Shipped", "Delivered", "Cancelled"]
    const [updatedStatus, setUpdatedStatus] = useState("Not Processed");
    const [isEditing, setIsEditing] = useState(false)

    const updateOrderStatus = (oId, status) => {
        console.log(oId, status);
        axios.post(SERVER_URL+"/api/admin/update-order-status", {
            oId: oId,
            status: status
        },
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization:
                        "Bearer " +
                        JSON.parse(localStorage.getItem("userTokenTime")).token,
                }
            }
        ).then((res) => {
            console.log(res.data);
            setRerender((prev) => prev + 1);
            setIsEditing(false);
        });
    }
    return (
        <React.Fragment>
            <tr>
                <td className="p-2 text-left">
                    {order.orderItems[0].id.pName.length > 15
                        ? order.orderItems[0].id.pName.substring(1, 15) + "..."
                        : order.orderItems[0].id.pName}
                </td>
                <td className="p-2 text-left">
                    {order.totalPrice}
                </td>
                <td className="p-2 text-left">
                    {order.transactionId}
                </td>
                <td className="p-2 text-left">
                    {order.user.first_name}
                </td>
                <td className="p-2 text-left">
                    {order.user.email}
                </td>
                <td className="p-2 text-left">
                    {order.shippingAddress.city}
                </td>
                {/* <td className="p-2 text-center">
          {product.cStatus === "Active" ? (
            <span className="bg-green-200 cat__status">
              {product.pStatus}
            </span>
          ) : (
            <span className="bg-red-200 cat__status">
              {product.pStatus}
            </span>
          )}
        </td> */}
                {/* <td className="p-2 text-center">{product.pQuantity}</td> */}
                {/* <td className="p-2 text-center">{product.pPrice}</td> */}
                {/* <td className="p-2 text-center">{product.pCategory.cName}</td> */}
                {/* <td className="p-2 text-center">{product.pOffer}</td> */}
                <td className="p-2 text-center">
                    {moment(order.createdAt).format("lll")}
                </td>
                <td className="p-2 text-center">
                    {moment(order.updatedAt).format("lll")}
                </td>
                <td className="p-2 text-center">
                    {!isEditing ? <>{order.status}</> :

                        <div className="form__input">
                            <select
                                // value={fData.pCategory}
                                onChange={(e) => {
                                    console.log(e.target.value)
                                    setUpdatedStatus(e.target.value)
                                }
                                }
                                name="status"
                                className="py-2 border focus:outline-none"
                                id="status"
                            >
                                <option disabled value="">
                                    Choose Status
                                </option>
                                {statuses.length > 0
                                    ? statuses.map(function (elem) {
                                        return (
                                            <option name="status" value={elem} key={elem}>
                                                {elem}
                                            </option>
                                        );
                                    })
                                    : ""}
                            </select>
                        </div>
                    }
                </td>
                <td className="flex flex-row items-center">
                    {!isEditing ?

                        <span
                            onClick={(e) =>
                                setIsEditing(() => true)
                            }
                            className="cat__update"
                        >
                            <svg
                                className="w-6 h-6 fill-current text-green-500"
                                style={{ color: "rgba(72, 187, 120)" }}
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z" />
                                <path
                                    fillRule="evenodd"
                                    d="M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z"
                                    clipRule="evenodd"
                                />
                            </svg>
                        </span>
                        :

                        <span
                            onClick={(e) =>
                                updateOrderStatus(
                                    order._id,
                                    updatedStatus
                                )
                            }
                            className="cat__update"
                        >
                            <IoMdSave style={{ color: "#16a34a", height: "24px", width: "24px", fontWeight: "bold" }} />
                        </span>
                    }
                </td>
            </tr>
        </React.Fragment>
    );
};

export default OrderRow